import React, { useState } from "react";
import dayjs from "dayjs";
import { message } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { capitalizeFirstLetter } from "../../../helpers/utility";
import paymentReceivedIcon from "../../../assets/receptionistIcons/ipBilling/paymentReceived.svg";
import {
  openPrintWindow,
  pharmacyPaymentReceiptApi,
} from "../../../services/pharmacyBilling.services";
import styles from "../../PatientsIP/ReceptionistIp/BillingIp/BillingIp.module.css";
import { formatMoney } from "../common/money";

const PharmacyBillPaymentHistory = ({ bill }) => {
  const payments = bill?.payments || [];
  const [printingId, setPrintingId] = useState(null);

  // `type=payment` selects the endpoint's per-payment branch (as opposed to a
  // whole-bill document), and `share=print` returns the receipt HTML for the
  // browser's print dialog. `share=download` would instead render a PDF to S3
  // and hand back a link.
  const printReceipt = async (paymentId) => {
    if (!bill?.id || !paymentId) return;
    setPrintingId(paymentId);
    try {
      const resp = await pharmacyPaymentReceiptApi(
        bill.id,
        `type=payment&payment_id=${paymentId}&share=print`
      );
      const html = resp?.data?.data;
      if (typeof html === "string" && html.includes("<")) {
        openPrintWindow(html);
      } else {
        message.error("Failed to load the receipt.");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Unable to print the receipt"
      );
    } finally {
      setPrintingId(null);
    }
  };

  return (
    <section className={styles.historyCard}>
      <h3 className={styles.historyTitle}>Payment history</h3>
      {payments.length === 0 ? (
        <p className={styles.emptyHistory}>No payments recorded yet</p>
      ) : (
        <div className={styles.historyList}>
          {payments.map((record) => (
            <article key={record.id} className={styles.historyItem}>
              <img src={paymentReceivedIcon} alt="" className={styles.historyIcon} />
              <div className={styles.historyMain}>
                <div className={styles.historyTop}>
                  <span className={styles.historyAmount}>{formatMoney(record.amount)}</span>
                  {record?.status === "success" ? (
                    <span className={styles.paidBadge}>Paid</span>
                  ) : (
                    <span className={styles.statusBadge}>
                      {capitalizeFirstLetter(record?.status || "—")}
                    </span>
                  )}
                </div>
                <div className={styles.historyMeta}>
                  {(record.payment_mode || "").toUpperCase()}
                  {record.payment_number ? ` · ${record.payment_number}` : ""}
                  {record.paid_at || record.created_at
                    ? ` · ${dayjs(record.paid_at || record.created_at).format("DD MMM, YYYY hh:mm A")}`
                    : ""}
                  {record.received_by_name ? ` · ${record.received_by_name}` : ""}
                </div>
              </div>
              <div className={styles.historyActions}>
                <button
                  type="button"
                  className={styles.iconAction}
                  onClick={() => printReceipt(record.id)}
                  disabled={printingId === record.id}
                  aria-label="Print receipt"
                  title="Print receipt"
                >
                  <PrinterOutlined />
                </button>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default PharmacyBillPaymentHistory;
